import { fetch_user_claims } from "./actions/queries";
import { connect } from "react-redux";
import { mergeProps } from "../shared/mergeProps";

const mapStateToProps = (state) => {
  return {
    claims: state.claims,
    fetched: state.claims.fetched,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchUserClaims: () => {
      dispatch(fetch_user_claims());
    },
  };
};

export const claimsConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
);
